import React from 'react';
import {
  useHistory,
  useLocation,
  // useNavigate,
  useParams
} from 'react-router-dom';
import { getConfirmableDiscardBatchChanges } from '@actions/batch-actions';
import {
  getConfirmableDiscardChanges,
  showConfirmationDialog
} from '@actions/confirmation-actions';

// Since we replaced the 'react-router' library with the 'react-router-dom' one,
// the withRouter method is no longer available, since we should use hooks with
// the new library.
//
// But since we still use old React components and components can't use hooks,
// we still need withRouter, thus here's the official implementation for those cases.
//
// See:
//
//     https://reactrouter.com/en/6.4.0/start/faq#what-happened-to-withrouter-i-need-it
//
export const withRouter = Component => {
  const ComponentWithRouterProp = props => {
    const history = useHistory();
    const location = useLocation();
    // const navigate = useNavigate();  // useNavigate is for react-router v6
    const params = useParams();
    return (
      <Component
        {...props}
        location={location}
        params={params}
        router={{ location, history, /* navigate, */ params }}
      />
    );
  };

  return ComponentWithRouterProp;
};

const showDiscardChangesDialog = (dispatch, confirmableAction) => {
  showConfirmationDialog(
    'Discard changes',
    'You have unsaved changes. Navigating away from this page without saving will discard the changes.',
    confirmableAction,
    { confirmationType: 'discard' }
  )(dispatch);
  return false;
};

export const routerWillLeave = (dispatch, nextLocation) => (
  showDiscardChangesDialog(dispatch, getConfirmableDiscardChanges(nextLocation.pathname))
);

export const batchRouterWillLeave = (dispatch, nextLocation, currentLocation) => {
  const { pathname: nextPathname } = nextLocation;
  const { pathname: currentPathname } = currentLocation;

  // If we hit the UPLOAD button, allow navigation:
  if (window.savingBatchUpload) {
    return true;
  }

  // i.e. '/batch-upload-edit/<file id>/<row id>':
  const currentFileId = currentPathname.split('/')[2];
  if (nextPathname.startsWith('/batch-upload-edit/') && currentPathname.startsWith('/batch-upload-edit/')) {
    const nextParts = nextPathname.split('/');
    const currentParts = currentPathname.split('/');
    if (nextParts.length >= 3 && currentParts.length >= 3) {
      const nextFileId = nextParts[2];
      if (nextFileId === currentFileId) {
        return true; // Allow navigation within the same batch edit page
      }
    }
  }

  // The batch changes are discarded by removing the batch (its edits are already
  // in the store, see batchEditSyncMiddleware):
  return showDiscardChangesDialog(
    dispatch, getConfirmableDiscardBatchChanges(currentFileId, nextLocation.pathname)
  );
};
